import Vue from 'vue'
import closeCargo from "@/mixins/closeCargo";

const catchScanExit = (router) => {
    router.beforeEach((to, from, next) => {
        if (from.name === 'loading' && to.name === 'loading-cargo-orders') {
            next();
        } else if (from.name === 'loading-cargo-orders' && to.name === 'registerDeviation') {
            next();
        } else if (from.name === 'registerDeviation' && to.name === 'loading-cargo-orders') {
            next();
        } else if (from.name === 'loading-cargo-orders' && to.name === 'loading-manual-order-product-change') {
            next();
        } else if (from.name === 'loading-manual-order-product-change' && to.name === 'loading-cargo-orders') {
            next();
        } else {
            closeCargo();
            next();
        }
    })
}

export default catchScanExit;